






import Vue from 'vue'
import { EmailHub } from '../event-hub'

export default Vue.extend({
  name: 'EmailPopupButton',
  props: {
    subject: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    mailto: {
      type: String,
      default: '',
    },
  },
  methods: {
    open() {
      EmailHub.$emit('openEmailPopup', this.$props)
    },
  },
})
